import {LitElement, html, css} from 'lit';
import {property} from 'lit/decorators/property.js';
import {customElement} from 'lit/decorators/custom-element.js';
import {repeat} from 'lit/directives/repeat.js';
import {when} from 'lit/directives/when.js';
import {classMap} from 'lit/directives/class-map.js';
import {connect} from 'pwa-helpers';

import info from '../../../icons/info';

import store from '../../store';

import {staggeredReveal} from '../../css/styleSets';
import {attributeWidget} from '../../css/attributeWidget';

@customElement('color-select')
export class ColorSelect extends connect(store)(LitElement) {

	@property({type: Object})
	title = {
		de: '[Titel]',
		en: '[Title]',
		fr: '[Title]'
	};

	@property({type: Array})
	options = [];

	@property({type: Function})
	selected = null;

	@property({type: Function})
	canBeSelected = () => true;

	@property({type: Function})
	isSatisfied = null;

	@property({type: String})
	action = '';

	@property({type: Function})
	callback  = null;

	@property({type: Boolean})
	hideDisabled = false

	@property({type: Function})
	isVisible = () => true;

	static styles = [
		staggeredReveal,
		attributeWidget,
		css`
			:host {}
		`];

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}
	stateChanged(state) {
		this.lang = state.status.lang;
	}

	render() {

		const s = store.getState();
		if (!this.isVisible(s)) return null;
		return html`
			<div>
				<div class="title">
					${this.title[this.lang]}
				</div>
				<div class="values ${classMap({notSatisfied: !this.isSatisfied(s)})}">
					${repeat([...this.options],
							(option) => option.id,
							(option) => html`
								<color-select-item .option=${option}
												  .canBeSelected=${this.canBeSelected(s, option.id)}
												  selected=${this.selected(s)}
												  .hideDisabled=${this.hideDisabled}
												  .callback=${this.callback}
												  action="${this.action}"></color-select-item>
							`)}
				</div>
			</div>

		`;
	}
}
